export const STATUS_DIAPLAY_MAP = Object.freeze({
	return: 'Returned',
	lms_sent: 'In Transport',
});
